export default {
  setRoles: (state, payload) => (state.roles = payload)
}
